'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const React = require('react');
const reactAria = require('react-aria');

const FocusableTrigger = (_a) => {
  var { children, className, onClick, onFocusChange, tag = "div" } = _a, props = tslib_es6.__rest(_a, ["children", "className", "onClick", "onFocusChange", "tag"]);
  const ref = React.useRef(null);
  const { focusableProps } = reactAria.useFocusable({ onFocusChange }, ref);
  const Tag = tag;
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    react.jsx(Tag, Object.assign({}, props, focusableProps, { className, "data-zds": true, onClick, ref, tabIndex: 0 }), children)
  );
};

exports.FocusableTrigger = FocusableTrigger;
//# sourceMappingURL=FocusableTrigger.cjs.js.map
